module.exports = __webpack_public_path__ + "imgs/facebook-white.30f02c09914e7b521f6d8e3548e1bcb3.svg";